import { InvokeCommand, LambdaClient } from '@aws-sdk/client-lambda';
import Axios from 'axios';
import * as qs from 'qs';
import { axiosTemplate } from '../../axiosTemplate';
import { getLoaders } from '../dataLoaders';
import { endpoints } from './endpoints';
const client = new LambdaClient({});
export const platformsWidgetblock = {
    endpoints,
    http: {
        create: ({ widgetblock, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).post(`${platformsWidgetblock.endpoints[stage]}/widgetblock`, widgetblock);
        },
        list: ({ stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).get(`${platformsWidgetblock.endpoints[stage]}/widgetblock`);
        },
        get: ({ stage, metjwt, cancelToken, widgetblockIds, headers }) => {
            const queryStringParameters = qs.stringify({ widgetblockIds }, { arrayFormat: 'comma' });
            return axiosTemplate(metjwt, cancelToken, headers).get(`${platformsWidgetblock.endpoints[stage]}/widgetblock/get?${queryStringParameters}`);
        },
        update: ({ widgetblock, id, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).put(`${platformsWidgetblock.endpoints[stage]}/widgetblock/${id}`, widgetblock);
        },
        remove: ({ widgetblockId, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).delete(`${platformsWidgetblock.endpoints[stage]}/widgetblock/${widgetblockId}`);
        },
        getData: ({ widgetblockId, stage }) => {
            return Axios.get(`${platformsWidgetblock.endpoints[stage]}/widgetblock/${widgetblockId}`);
        },
        batch: {
            getWidgetblock: ({ stage, metjwt, widgetblockId, headers }) => {
                return getLoaders().platformsWidgetblock.getWidgetblockLoader.load({ stage, metjwt, widgetblockId, headers });
            },
        },
    },
    invocations: {
        get: {
            generateArn: (stage) => `arn:aws:lambda:us-east-1:030010709664:function:${stage}-platforms-widgetblock-get`,
            invoke: async ({ widgetblockId, stage, lambda }) => {
                const command = new InvokeCommand({
                    FunctionName: `${stage}-platforms-widgetblock-get`,
                    InvocationType: 'RequestResponse',
                    //@ts-ignore this is a typing is a lie, it actually wants JSON
                    Payload: JSON.stringify({
                        widgetblockId,
                    }),
                });
                const { Payload } = await lambda.send(command);
                if (!Payload)
                    return { error: 'no payload', widgetblock: null };
                const result = Buffer.from(Payload).toString();
                const response = JSON.parse(result);
                return response;
            },
        },
        updateRelations: {
            generateArn: (stage) => `arn:aws:lambda:us-east-1:030010709664:function:${stage}-platforms-widgetblock-updateRelations`,
            invoke: async ({ widgetblockId, mrn, addOrSubtract, stage, lambda }) => {
                const command = new InvokeCommand({
                    FunctionName: `${stage}-platforms-widgetblock-updateRelations`,
                    InvocationType: 'RequestResponse',
                    //@ts-ignore this is a typing is a lie, it actually wants JSON
                    Payload: JSON.stringify({
                        widgetblockId,
                        mrn,
                        addOrSubtract,
                    }),
                });
                const { Payload } = await lambda.send(command);
                if (!Payload)
                    return { error: 'no payload' };
                const result = Buffer.from(Payload).toString();
                const response = JSON.parse(result);
                return response;
            },
        },
    },
};
